import { EditRejected, type Edit, type Json } from '@w/crdt'
import { deriveJsonPatch, isObject } from '@w/utils'
import { isEntryScalarField } from '../db/page-document'
import type { LexiconEntry } from './lexicon-model'

export function editEntry(tx: Edit, current: LexiconEntry, next: LexiconEntry): void {
  const structure = (entry: LexiconEntry) => Object.fromEntries(Object.entries(entry).filter(([key, value]) => !isEntryScalarField(key, value)))
  const before = structure(current)
  const after = structure(next)
  apply(tx, 'content.entry', before, after, deriveJsonPatch(before, after))
}

function apply(tx: Edit, path: string, current: Record<string, unknown>, next: Record<string, unknown>, patch: Record<string, unknown>): void {
  for (const key of Object.keys(patch)) {
    const value = next[key]
    if (value === undefined) tx.delete(path, key)
    else if (isObject(value) && isObject(current[key]) && !key.includes('.')) {
      apply(tx, `${path}.${key}`, current[key], value, patch[key] as Record<string, unknown>)
    } else if (isObject(value) && key.includes('.')) {
      const parent = tx.read(path)
      const live = isObject(parent) ? parent[key] : undefined
      const previous = current[key]
      if (live !== previous && (!isObject(live) || !isObject(previous) || Object.keys(deriveJsonPatch(previous, live)).length > 0)) {
        throw new EditRejected('Entry map changed before literal-key replacement')
      }
      tx.replaceContainer(path, key, value as Json)
    } else if (isObject(value)) {
      tx.set(path, key, {})
      apply(tx, `${path}.${key}`, {}, value, value)
    }
    else tx.set(path, key, value as Json)
  }
}
